interface DeviceNavigator {
    userAgentData?: { platform?: string; mobile?: boolean };
    userAgent: string;
    platform: string;
    maxTouchPoints?: number;
}

// Device information is best effort: do not classify an unknown browser as desktop.
export const getClientDevice = (client: DeviceNavigator): { platform: string | null; mobile: boolean | null } => {
    const ua = client.userAgent || '';
    const isIPad = /iPad/i.test(ua) || (/Mac/i.test(client.platform) && (client.maxTouchPoints || 0) > 1);
    const isIOS = isIPad || /iPhone|iPod/i.test(ua);
    let platform = client.userAgentData?.platform?.trim() || null;
    if (!platform) {
        if (isIOS) platform = isIPad ? 'iPadOS' : 'iOS';
        else if (/Android/i.test(ua)) platform = 'Android';
        else if (/Windows/i.test(ua)) platform = 'Windows';
        else if (/CrOS/i.test(ua)) platform = 'Chrome OS';
        else if (/Macintosh|Mac OS X/i.test(ua)) platform = 'macOS';
        else if (/Linux/i.test(ua)) platform = 'Linux';
    }
    // Include tablets, even when iPadOS requests the desktop version of a site.
    const mobile = isIOS || /Android|Mobile|Tablet/i.test(ua)
        ? true
        : typeof client.userAgentData?.mobile === 'boolean'
            ? client.userAgentData.mobile
            : platform && ['Windows', 'macOS', 'Chrome OS', 'Linux'].includes(platform)
                ? false : null;
    return { platform, mobile };
};
